import { render, staticRenderFns } from "./AddFundToSeries.vue?vue&type=template&id=d54daaa0&scoped=true&"
import script from "./AddFundToSeries.vue?vue&type=script&lang=js&"
export * from "./AddFundToSeries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54daaa0",
  null
  
)

export default component.exports